module.exports = "<div class=cover-image hm-tap=\"$ctrl.AppServices.PixiManager.setCover('{{$ctrl.options.image}}', true)\" style=background-image:url({{$ctrl.AppServices.DataManager.config.settings.assetsPath}}{{$ctrl.options.image}})></div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/cover-image/cover-image.html
 ** module id = 77
 ** module chunks = 0
 **/